import { render, staticRenderFns } from "./MPopupMes.vue?vue&type=template&id=e075556a&"
import script from "./MPopupMes.vue?vue&type=script&lang=ts&"
export * from "./MPopupMes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports